var _excluded = ["barLinks", "account"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { forwardRef, useCallback, useContext, useEffect, useRef, useState } from "react";
import OnColorContext from "../../../../../contexts/OnColorContext";
import useBreakpoint from "../../../../../hooks/useBreakpoint";
import { useFocusWrapper } from "../../../../../hooks/useFocusWrapper";
import { KeyboardEventKeys } from "../../../../../typings/types";
import { breakpointValue } from "../settings";
import AccountButtonMol from "./AccountButtonMol";
import AccountDropdownOrg from "./AccountDropdownOrg";
import BarLinksOrg from "./BarLinksOrg";
import { AccountButtonWrapper, AccountDropdownWrapper, AccountWrapper, Bar } from "./BarOrg.styled";
var BarOrg = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var barLinks = _ref.barLinks,
    account = _ref.account,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var onColor = useContext(OnColorContext);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isAccountActive = _useState2[0],
    setIsAccountActive = _useState2[1];
  var _useFocusWrapper = useFocusWrapper(),
    focusWrapperRef = _useFocusWrapper.focusWrapperRef,
    isWrapperFocused = _useFocusWrapper.isWrapperFocused,
    handleOnFocusWrapper = _useFocusWrapper.handleOnFocusWrapper,
    handleOnBlurWrapper = _useFocusWrapper.handleOnBlurWrapper;
  var dropdownWrapperRef = useRef(null);
  var isBiggerScreen = useBreakpoint(breakpointValue);
  var handleAccountButtonClick = useCallback(function () {
    var onAccountClick = account === null || account === void 0 ? void 0 : account.onClick;
    setIsAccountActive(function (value) {
      return !value;
    });
    if (onAccountClick) {
      onAccountClick();
    }
  }, [account, isBiggerScreen]);
  var handleAccountButtonOnKeyDown = function handleAccountButtonOnKeyDown(event) {
    if (event.key === KeyboardEventKeys.ESC && isAccountActive) {
      setIsAccountActive(false);
    }
  };
  var handleAccountButtonMouseEnter = useCallback(function () {
    var onAccountMouseEnter = account === null || account === void 0 ? void 0 : account.onMouseEnter;
    if (isBiggerScreen) {
      setIsAccountActive(true);
    }
    if (onAccountMouseEnter) {
      onAccountMouseEnter();
    }
  }, [account, isBiggerScreen]);
  var handleAccountMouseLeave = function handleAccountMouseLeave() {
    return setIsAccountActive(false);
  };
  var handleAccountOutsideTouch = function handleAccountOutsideTouch(event) {
    var _focusWrapperRef$curr;
    if ((_focusWrapperRef$curr = focusWrapperRef.current) !== null && _focusWrapperRef$curr !== void 0 && _focusWrapperRef$curr.contains(event.target)) {
      return;
    }
    setIsAccountActive(false);
  };
  useEffect(function () {
    document.addEventListener("touchstart", handleAccountOutsideTouch);
    return function () {
      document.removeEventListener("touchstart", handleAccountOutsideTouch);
    };
  }, []);
  useEffect(function () {
    setIsAccountActive(!!isWrapperFocused);
  }, [isWrapperFocused]);
  return /*#__PURE__*/React.createElement(Bar, _extends({
    $background: onColor,
    ref: ref,
    role: "navigation"
  }, restProps), /*#__PURE__*/React.createElement(BarLinksOrg, {
    barLinks: barLinks
  }), account ? /*#__PURE__*/React.createElement(AccountWrapper, {
    onMouseLeave: handleAccountMouseLeave
  }, /*#__PURE__*/React.createElement(AccountButtonWrapper, {
    "data-test-id": "client-icon"
  }, /*#__PURE__*/React.createElement(AccountButtonMol, {
    name: account.name,
    type: account.type,
    isActive: isAccountActive,
    onClick: handleAccountButtonClick,
    onKeyDown: handleAccountButtonOnKeyDown,
    onMouseEnter: handleAccountButtonMouseEnter
  })), /*#__PURE__*/React.createElement("div", {
    ref: focusWrapperRef,
    onFocus: handleOnFocusWrapper,
    onBlur: handleOnBlurWrapper
  }, /*#__PURE__*/React.createElement(AccountDropdownWrapper, {
    $isActive: isAccountActive,
    $additionalTopOffsetUnit: account.additionalDropdownTopOffsetUnit,
    ref: dropdownWrapperRef
  }, /*#__PURE__*/React.createElement(AccountDropdownOrg, _extends({}, account.dropdown, {
    setIsAccountActive: setIsAccountActive
  }))))) : null);
});
export default BarOrg;